<!-- 
  详情页 - 出库产品信息
  props:
    id: 详情id
 -->

<template>
	<div class="v-tabs product-list">
    <div class="content">
      <el-table
        :data="tableData"
        border
        highlight-current-row
        style="width: 100%"
        @click.native="tableClick">
        <el-table-column
          label="产品图片"
          width="100"
        ><template slot-scope="scope">
          <img
            data-type="img"
            :data-url="scope.row.thumbnail"
            :src="scope.row.thumbnail"
            height="30"
            width="30">
            </template>
        </el-table-column>
        <el-table-column
          property="name"
          label="产品名称"
          width="180"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          property="productNo"
          label="编号"
          width="180"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="产品规格"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.specification || '--'}}
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrapper" v-show="page.count > page.size">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.page"
          :page-size="page.size"
          layout="total, prev, pager, next, jumper"
          :total="page.count">
        </el-pagination>
      </div>  
    </div>
	</div>
</template>

<script>
import * as api from 'src/api'
import lightBox from 'src/plugins/lightbox'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    }
  },
  data () {
    return {
      tableData: [],
      page: {
        page: 1,
        size: 15,
        count: 0
      }
    }
  },
  computed: {
    totalProducts () {
      let i = 0
      this.tableData.forEach(item => {
        // i += Number(item.stock)
        let stock = Number(item.stock)
        i = utils.plus(i, stock)
      })
      return i
    }
  },
  methods: {
    getList () {
      let url = '/supplier/getProduct.html'
      let params = {
        supplierId: this.id,
        page: this.page.page,
        pageSize: this.page.size
      }
      api.post(url, params, (data) => {
        this.tableData = data.result
        this.page.count = data.pageHelper.rowsCount
      })
    },
    // 每页所显示的条数变更
    handleSizeChange (val) {
      this.page.size = val
      this.getList()
    },
    // 当前分页变更
    handleCurrentChange (val) {
      this.page.page = val
      this.getList()
    },
    // 监听table点击事件
    tableClick (event) {
      // 获取目标元素或目标父元素的data属性集合
      let data = event.target.dataset
      // 如果存在type属性，则是一个可执行的事件
      if (data.type && data.type === 'img') {
        lightBox(data.url)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .pagination-wrapper {
    margin-top: 10px;
  }
</style>


// WEBPACK FOOTER //
// product-list.vue?119b41de